import axios from 'axios'
import { BillableConceptResponse } from '@/api/services/billing/common-billable-concept/billing-common-billable-concept.dto'

class BillingCommonBillableConceptService {
    async getActiveBillableConcepts(
        laboratoryId: number
    ): Promise<BillableConceptResponse[]> {
        const response =
            await axios.get<BillableConceptResponse[]>(
                `/billing/laboratories/${laboratoryId}/billableConcepts`)
        return response.data
    }
}
export const billingCommonBillableConceptService = new BillingCommonBillableConceptService()
